/**
 * Parses a MarginContainer. It adds no fields to Control: its padding comes from
 * `theme_override_constants/margin_{left,top,right,bottom}`, which the Control parser collects.
 */
import { parseControl } from '../control/parser';
export function parseMarginContainer(heading, properties) {
    return parseControl(heading, properties);
}
//# sourceMappingURL=parser.js.map